import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_ENDPOINT;

export const fetchCustomerReminders = createAsyncThunk(
  "customer-reminders",
  async (_, { getState, rejectWithValue }) => {
    try {
      const kodecabang = { kodecabang: localStorage.getItem("kodecabang") };
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.post(`${API_URL}/customer-reminders`, kodecabang, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // ⬅️ Tambahkan fallback supaya aman
      const data = response.data?.data?.data;
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error("Error fetching customer reminders data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch test drive data"
      );
    }
  }
);

export const storeCustomerReminders = createAsyncThunk(
  "customer-reminders/store",
  async (items, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.post(`${API_URL}/customer-reminders/store`, items, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error store customer reminders data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to store Customer Reminders data"
      );
    }
  }
);

// paperless
export const storeUpdatePaperless = createAsyncThunk(
  "paperless/update",
  async (items, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.post(`${API_URL}/paperless/update`, items, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error store Update Paperless data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to store Update Paperless data"
      );
    }
  }
);

export const storeSendPaperless = createAsyncThunk(
  "paperless/send",
  async (items, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.post(`${API_URL}/paperless/send`, items, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error store Send Paperless data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to store Send Paperless data"
      );
    }
  }
);

export const storeClaim = createAsyncThunk(
  "send-claim/sendclaim",
  async (items, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.post(`${API_URL}/send-claim/sendclaim`, items, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error Send To Towass data:", error);
      return rejectWithValue(
        error.response?.data || "Failed Send To Towass data"
      );
    }
  }
);

// fetch detail
export const fetchReminderDetail = createAsyncThunk(
  "estimasi-detail/getEstimasiDetail",
  async (nomor, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.get(`${API_URL}/estimasi-detail/${nomor}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data.data;
    } catch (error) {
      console.error("Error fetching reminder detail:", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch reminder detail"
      );
    }
  }
);

export const fetchEventLog = createAsyncThunk(
  "event/eventlog",
  async (items, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.post(`${API_URL}/event/eventlog`, items, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data.data;
    } catch (error) {
      console.error("Error fetching event log:", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch event log"
      );
    }
  }
);

const customerRemindersSlice = createSlice({
  name: "customerReminders",
  initialState: {
    customer_reminders: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Detail dan EventLog tetap sama
      .addCase(fetchReminderDetail.pending, (state) => {
        state.detailLoading = true;
        state.detailError = null;
      })
      .addCase(fetchReminderDetail.fulfilled, (state, action) => {
        state.detailLoading = false;
        state.detailData = action.payload;
      })
      .addCase(fetchReminderDetail.rejected, (state, action) => {
        state.detailLoading = false;
        state.detailError = action.payload;
      })
      .addCase(fetchEventLog.pending, (state) => {
        state.detailLoading = true;
        state.detailError = null;
      })
      .addCase(fetchEventLog.fulfilled, (state, action) => {
        state.detailLoading = false;
        state.detailData = action.payload;
      })
      .addCase(fetchEventLog.rejected, (state, action) => {
        state.detailLoading = false;
        state.detailError = action.payload;
      })

      // Fetch utama
      .addCase(fetchCustomerReminders.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCustomerReminders.fulfilled, (state, action) => {
        state.isLoading = false;
        // ⬅️ selalu array, tidak akan undefined
        state.customer_reminders = Array.isArray(action.payload)
          ? action.payload
          : [];
      })
      .addCase(fetchCustomerReminders.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      // Store (update/create)
      .addCase(storeCustomerReminders.fulfilled, (state, action) => {
        if (!Array.isArray(state.customer_reminders)) {
          state.customer_reminders = [];
        }

        const payload = action.payload?.data;
        const actionType = action.payload?.action;

        if (!payload) return; // kalau kosong, abaikan

        if (actionType === "created") {
          // Tambah data baru
          state.customer_reminders.push(payload);
        } else {
          // Update data lama dengan aman
          const index = state.customer_reminders.findIndex(
            (item) => item.reminder_id === payload.reminder_id
          );

          if (index !== -1) {
            state.customer_reminders[index] = {
              ...state.customer_reminders[index],
              ...payload,
            };
          } else {
            // Jika tidak ketemu, push aja biar aman
            state.customer_reminders.push(payload);
          }
        }

        state.isLoading = false;
      })
      .addCase(storeCustomerReminders.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default customerRemindersSlice.reducer;
